<template>
  <div class="notfound d-flex align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
               <h3>Page Not Found.</h3>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {

};
</script>
<style scoped>
.notfound {
  height: 100vh;
}
</style>
